import SCIEditServicesListContainer from './SCIEditServicesListContainer';

export default SCIEditServicesListContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/SCIEditServicesList/index.js